import { CancelToken } from 'axios';
import { PagedList } from '../../types/dataQueries/base/PagedList';
import { PDADataService } from './PDADataService';

export abstract class ReadDataService<TModel, TQuery, TKey> extends PDADataService {
    fetch(query: TQuery, cancelToken?: CancelToken) {
        return this.api.get<TModel[]>(`${this.prefixUrl}/fetch?query=${encodeURIComponent(JSON.stringify(query))}`, {
            cancelToken,
        });
    }

    currentInstanceFetch(folderId: number, cancelToken?: CancelToken) {
        return this.api.get<TModel[]>(`${this.prefixUrl}/CurrentInstanceFetch?folderId=` + folderId, { cancelToken });
    }

    prevInstanceFetch(folderId: number, cancelToken?: CancelToken) {
        return this.api.get<TModel[]>(`${this.prefixUrl}/PrevInstanceFetch?folderId=` + folderId, { cancelToken });
    }

    previousIterationFetch(folderId: number, cancelToken?: CancelToken) {
        return this.api.get<TModel[]>(`${this.prefixUrl}/PreviousIterationFetch?folderId=` + folderId, { cancelToken });
    }

    fetchPaged(query: TQuery, cancelToken?: CancelToken) {
        return this.api.get<PagedList<TModel>>(
            `${this.prefixUrl}/fetchpaged?query=${encodeURIComponent(JSON.stringify(query))}`,
            { cancelToken },
        );
    }

    getById(id: TKey, cancelToken?: CancelToken) {
        return this.api.get<TModel>(`${this.prefixUrl}/getById?id=${id}`, {
            cancelToken,
        });
    }
}
